module.exports = __webpack_public_path__ + "img/0ee85959607ea6e69d5145f57b2873dd.910061f4.png";